import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=bfafc8c0&scoped=true"
import script from "./Filters.vue?vue&type=script&lang=js"
export * from "./Filters.vue?vue&type=script&lang=js"
import style0 from "./Filters.vue?vue&type=style&index=0&id=bfafc8c0&prod&scoped=true&lang=css"
import style1 from "./Filters.vue?vue&type=style&index=1&id=bfafc8c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfafc8c0",
  null
  
)

export default component.exports